//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext, useEffect, useId } from 'react';

import {
  UnsavedChangesContext, type UnsavedChangesContextValue
} from './UnsavedChangesContext';

export const useUnsavedChanges = (): UnsavedChangesContextValue => {
  const value = useContext(UnsavedChangesContext);
  if (value === null)
    throw new Error(
      'useUnsavedChanges must be used within an UnsavedChangesProvider');
  return value;
};

// Reports the caller's unsaved edits while it is mounted, so the Settings
// modal asks before a pane switch or a close unmounts them.
export const useReportUnsaved = (unsaved: boolean) => {
  const { report } = useUnsavedChanges();
  const owner = useId();
  useEffect(() => { report(owner, unsaved); }, [report, owner, unsaved]);
  useEffect(() => () => report(owner, false), [report, owner]);
};
